<template>
  <div>
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="900"
    >
      <v-card class="cardSize">
        <v-flex class="ml-4 mr-4">
          <v-layout row wrap fill-height>

            <v-flex v-if="step == 0" xs12 class="mb-4 pt-4">
              <v-layout class="mb-4">
                <v-icon style="font-size: 40px;" color="primary mr-4">chat_bubble_outline</v-icon>
                <h2
                  :style="`color: ${$vuetify.theme.primary}`"
                >{{$translate('CHOOSE_MESSAGE_OPTION')}}</h2>
              </v-layout>

              <v-list v-if="!isCampaign" two-line class="elevation-2 round_dialog_roles">
                <v-radio-group :mandatory="true" v-model="typeMessage">
                  <template v-for="(item, index) in items">
                    <v-list-tile @click="itemType({'name': item.name, 'id':item.id })" :key="index">
                      <v-list-tile-action>
                        <v-radio :value="item.id" :key="item.id"></v-radio>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $translate(item.name) }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ $translate(item.description) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-radio-group>
              </v-list>
              <v-list v-else two-line class="elevation-2 round_dialog_roles">
                <v-radio-group :mandatory="true" v-model="typeMessage">
                  <template v-for="(item, index) in itemsPartner">
                    <v-list-tile @click="itemType({'name': item.name, 'id':item.id })" :key="index">
                      <v-list-tile-action>
                        <v-radio :value="item.id" :key="item.id"></v-radio>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ $translate(item.name) }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ $translate(item.description) }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-radio-group>
              </v-list>
              <v-layout row align-end justify-end>
                <v-btn
                  color="secondary"
                  round
                  class="v-btn-2 text-capitalize"
                  @click="closeMessageScreen(true)"
                >{{$translate('CANCEL')}}</v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  round
                  :disabled="disableNext"
                  class="v-btn-2 text-capitalize"
                  @click="goToStep"
                >{{$translate('NEXT')}}</v-btn>
              </v-layout>
            </v-flex>

            <v-flex v-if="step == 1" xs12 class="pt-4">
              <v-form ref="form" v-model="formValid">
                <v-layout justify-center>
                  <h3 class v-if="!editMessage">
                    <span
                      :style="`color: ${$vuetify.theme.primary}`"
                    >{{$translate('SINGLE_MESSAGE')}}</span>
                  </h3>
                  <h3 class v-if="editMessage">
                    <span :style="`color: ${$vuetify.theme.primary}`">{{$translate('EDIT_MESSAGE')}}</span>
                  </h3>
                </v-layout>
                <v-layout justify-center>
                  <h3
                    v-if="!editMessage"
                    :style="`color: ${$vuetify.theme.primary}`"
                  >{{$translate('NEW_MESSAGE')}}</h3>
                </v-layout>
                <div>
                  <v-layout row justify-space-between>
                  <v-flex xs5>
                  <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHOM')}}</h3>
                  <h4 class="mt-2">{{$translate('SELECTION_OF_USERS')}}</h4>
                  <v-select
                    outline
                    v-model="form.ToEventSubscribers"
                    :items="messageCriteriaOptions"
                    item-text="criteriaName"
                    item-value="criteriaId"
                  ></v-select>
                  <h3
                    :style="`color: ${$vuetify.theme.primary}`"
                    class="mt-2"
                  >{{$translate('WHAT')}}</h3>
                  <h4 class="mt-2">{{$translate('MESSAGE_CATEGORY')}}</h4>
                    <v-select
                      :items="availableTags"
                      item-text="name"
                      outline
                      return-object
                      v-model="form.tags"
                      :label="$translate('SELECT_MESSAGE_CATEGORY')">
                    </v-select>
                  <h4 class="mt-4">{{$translate('TITLE_MESSAGE')}}</h4>
                  <v-textarea
                    rows="1"
                    auto-grow
                    v-model="form.Title"
                    :counter="50"
                    outline
                    :rules="textRules"
                    ref="eventForm"
                  />
                  <h4>{{$translate('TEXT_MESSAGE')}}</h4>
                  <v-textarea
                    rows="1"
                    auto-grow
                    multiple
                    v-model="form.Text"
                    :rules="textRules"
                    :counter="1024"
                    outline
                    ref="eventForm"
                  />
                  <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('WHEN')}}</h3>

                  <v-layout wrap>
                    <v-flex xs12 md6 class="paddingRight">
                      <h4>{{$translate('DATE')}}</h4>
                      <v-menu
                        ref="menu1"
                        :close-on-content-click="true"
                        v-model="menu1"
                        :nudge-right="40"
                        :return-value.sync="form.date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <v-text-field
                          clearable
                          slot="activator"
                          v-model="form.date"
                          @input="checkForDate"
                          outline
                          hide-details
                          append-icon="event"
                          readonly
                          ref="eventForm"
                        ></v-text-field>
                        <v-date-picker
                          first-day-of-week="1"
                          color="primary"
                          v-model="form.date"
                          @change="checkForDate"
                          no-title
                          scrollable
                        />
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 md6 class="paddingLeft">
                      <h4>{{$translate('TIME')}}</h4>
                      <v-text-field
                        v-model="form.time"
                        @input="checkForTime"
                        outline
                        mask="time"
                        hint="Input: hh:mm"
                        ref="eventForm"
                        type="time"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  </v-flex>
                    <v-flex xs6>
                      <h3 :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_PIC_SHORT')}}</h3>
                      <h4 class="mt-2">{{$translate('EVENT_MESSAGE_PICTURE')}}</h4>
                      <image-loader
                        :properties="imageProperties"
                        v-on:load_image="setImageElement"
                      ></image-loader>
                      <h3 v-if="orderEventActive" :style="`color: ${$vuetify.theme.primary}`">{{$translate('EVENT_MESSAGE_PRODUCT_OPT')}}</h3>
                      <h4 v-if="orderEventActive" class="mt-2">{{$translate('EVENT_MESSAGE_PRODUCT')}}</h4>
                      <v-select
                        v-if="orderEventActive"
                        :items="products"
                        item-text="Name"
                        item-value="Id"
                        outline
                        v-model="form.selectedProduct"
                        :label="$translate('EVENT_MESSAGE_SELECT_PRODUCT')">
                      </v-select>
                      <v-layout class="mt-4" row align-center justify-center>
                        <v-btn
                          round
                          color="secondary"
                          class="v-btn-2 text-capitalize"
                          @click="moveToStep"
                        >{{$translate('BACK')}}</v-btn>
                        <v-btn
                          round
                          color="primary"
                          class="v-btn-2 text-capitalize"
                          @click="saveSingleMessage"
                          :disabled="!isDateFilled"
                        >{{$translate('SAVE')}}</v-btn>
                        <v-btn
                          round
                          color="primary"
                          class="v-btn-2 text-capitalize"
                          v-if="!editMessage"
                          @click="sendSingleMessage"
                          :disabled="isDateFilled"
                        >{{$translate('SEND')}}</v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </div>
              </v-form>

            </v-flex>
            <v-flex v-if="step == 2" xs12 class="pt-4">
              <EngagementCampaign
                v-on:backButton="moveToStep"
                v-on:closeDialog="closeMessageScreen"
                :eventData="eventData"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-card>
      <v-dialog v-model="wrongInput" max-width="320" persistent content-class="dialog_class">
        <v-card>
          <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
          <v-card-text>
            <h3>
              {{$translate('WRONG_TIME_INPUT')}}
              <br>
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="text-capitalize"
              round
              @click="wrongInput= false"
            >{{$translate('CANCEL')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <v-dialog v-model="missingData" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>{{$translate('MESSAGE_TITLE_TEXT')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="missingData = false">{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
// import * as parser from "@/api/Parser";
import * as player from "@/shared/player";
import { mapGetters } from "vuex";
import BaseObject from "@/objects/BaseObject";
import appConfig from "../../config/app_config";
import CommunicationCenterObject from "@/objects/CommunicationCenterObject";
import ExpendableTags from "@/components/ExpendableTags";
import LindaOutputDynamic from "@/components/LindaOutputDynamic";
import WebStepper from "@/components/WebStepper";
import BaseComponent from "@/components/base/BaseComponent";
import ImageLoader from "@/components/media/ImageLoader";
import EngagementCampaign from "@/components/EngagementCampaign";
import _ from "lodash";
import { setTimeout } from "timers";
import * as dssRequest from "@/api/dssRequest";


export default {
  name: "SingleMessageDialog",
  extends: BaseComponent,
  components: {
    ImageLoader,
    LindaOutputDynamic,
    WebStepper,
    ExpendableTags,
    EngagementCampaign
  },
  props: {
    showDialog: Boolean,
    messageData: Object,
    eventData: Object,
    isCampaign: Boolean
  },

  watch: {
    showDialog: function(newVal, oldVal) {
      console.log("showDialog messageData ", newVal, oldVal, this.messageData);
      if (newVal == true) {
        if (!_.isEmpty(this.messageData)) {
          this.loadMessageData();
        } else {
          this.cleanDialog();
        }
      }
    }
  },
  data() {
    return {
      imageProperties: {
        title: "Message Picture",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w"
      },
      messageCriteriaOptions: [
        { criteriaId: 0, criteriaName: this.$translate("CRITERIA_BOTH") },
        { criteriaId: 1, criteriaName: this.$translate("CRITERIA_REG") },
        { criteriaId: 2, criteriaName: this.$translate("CRITERIA_NOT_REG") }
      ],
      missingData: false,
      wrongInput: false,
      preselection: [],
      showOnlyOne: ["MessageCategory"],
      disableNext: true,
      items: [
        {
          id: "single",
          name: "SINGLE_MESSAGE",
          description: "SINGLE_MESSAGE_SUB"
        },
        {
          id: "campaign",
          name: "ENGAGEMENT_CAMPAIGN",
          description: "ENGAGEMENT_CAMPAIGN_SUB"
        }
      ],
      itemsPartner: [
        {
          id: "single",
          name: "SINGLE_MESSAGE",
          description: "SINGLE_MESSAGE_SUB"
        },
        {
          id: "campaign",
          name: "ENGAGEMENT_CAMPAIGN",
          description: "ENGAGEMENT_CAMPAIGN_SUB"
        }
      ],
      step: 0,
      typeMessage: "",
      linda_icon: "Linda_planning",
      linda_text1: this.$translate("MESSAGE_TITLE_1"),
      linda_text2: this.$translate("MESSAGE_TITLE_2"),
      lindaBubbleSize: "",
      formValid: "",
      orderEventActive: false,
      textRules: [
        v => !!v || "Text is required",
        v => (v && v.length <= 1024) || "Text must be less than 1024 characters"
      ],
      availableTags: [],
      editMessage: false,
      isDateFilled: false,
      menu1: false,
      products: [],
      menu2: false,
      form: {
        Title: "",
        Text: "",
        PromoCode: "",
        tags: [],
        time: null,
        date: null,
        ToEventSubscribers: null
      }
      // promotionCode: ["3XWRY", "5TBON", "8JTIO", "9PUTI"],
    };
  },
  created() {
    window.EventBus.listen("inputDialog", this.inputDialog);
    this.cleanDialog();
    if (
      this.messageData != undefined &&
      this.messageData.hasOwnProperty("UnitId")
    ) {
      this.loadMessageData();
    }
    setTimeout(() => {
      this.getProducts();
      this.setTags();
    }, 250);
  },
  beforeDestroy() {
    window.EventBus.removeListener("inputDialog", this.inputDialog);
  },
  computed: {
    ...mapGetters({
      tags: "getAllTags"
    }),
    computedDateFormatted() {
      return this.formatDate(this.form.date);
    }
  },
  methods: {
    setTags() {
      let usableTags = [];
      this.$store.getters.getFilterTags.forEach( e => {
        if (e.title === 'MessageCategory') {
          e.entries.forEach( a => {
            usableTags.push({id: a.k, name: a.v, group: a.group})
          })
        }
      });
      this.availableTags = [];
      this.availableTags = usableTags;
    },
    getProducts(){

      if (this.eventData.type !== 'OrderEvent' && this.eventData.type !== 'Rental') {
        return;
      }
      this.orderEventActive = true;
      const payload = {
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getProducts was successful",
            response
          );
          for (let [index, item] of Object.entries(response.data.Products)){
            this.products.push({Id: item.Id, Name: item.Name })
          }

        },
        error => {
          console.log(
            "The generic call getProducts was not successful",
            error
          );
        },
        "getProducts",
        this.eventData.eventId,
        payload
      );
    },
    inputDialog() {
      console.log("inputDialog wrongInput");
      this.wrongInput = true;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
      console.log("date formatted", this.form.date);
    },
    cleanDialog() {
      this.imageProperties.pictureUrl = '';
      this.preselection = [];
      this.form.date = '';
    },
    setSelectedTags(data) {
      console.log("setSelectedTags the data for tags: ", data);
      this.form.tags = data;
    },
    setImageElement(e) {
      if (e.signalName == this.imageProperties.signalName) {
        this.imageProperties.pictureUrl = e.url;
      }
    },
    loadMessageData() {
      console.log("loadMessageData", this.messageData);
      this.step = 1;
      this.setEditMessage();
      this.editMessage = true;
      this.isDateFilled = true;
    },
    itemType(payload) {
      this.typeMessage = payload.id;
      this.disableNext = false;
    },
    goToStep() {
      if (this.typeMessage == "single") {
        this.cleanDialog();
        this.step = 1;
        this.linda_text1 = this.$translate("MESSAGE_TITLE_3");
        this.linda_text2 = this.$translate("MESSAGE_TITLE_4");
      } else if (this.typeMessage == "campaign") {
        this.cleanDialog();
        this.step = 2;
        this.linda_text1 = this.$translate("MESSAGE_TITLE_5");
        this.linda_text2 = this.$translate("MESSAGE_TITLE_4");
      }
    },
    moveToStep() {
      if (this.editMessage) {
        this.closeMessageScreen();
        this.editMessage = false;
      }
      setTimeout(() => {
        this.step = 0;
      }, 100);
      // this.step = 0;
    },
    setMessageType(typeMessage) {
      this.typeMessage = typeMessage;
    },
    setEditMessage() {
      let d = this.messageData.DateTime.split(" - ")[1]
        .split("-")
        .reverse()
        .join("-");
      let t = this.messageData.DateTime.split(" - ")[0];
      console.log("setEditMessage", this.messageData, d, t);

      this.form.date = d;
      this.form.time = t;
      if (this.messageData.ToEventSubscribers != null) {
        if (this.messageData.ToEventSubscribers == 0) {
          this.form.ToEventSubscribers = this.messageCriteriaOptions[0].criteriaId;
        } else if (this.messageData.ToEventSubscribers == 1) {
          this.form.ToEventSubscribers = this.messageCriteriaOptions[1].criteriaId;
        } else {
          this.form.ToEventSubscribers = this.messageCriteriaOptions[2].criteriaId;
        }
      } else {
        this.form.ToEventSubsribers = this.messageCriteriaOptions[0];
      }
      this.form.Title = this.messageData.Title;
      this.form.Text = this.messageData.Text;
      this.form.selectedProduct = this.messageData.ProductId;
      this.imageProperties.pictureUrl = this.messageData.ThumbnailPicture;
      this.form.tags = {
        id: this.messageData.TagId,
        name: this.messageData.Description,
        group: this.messageData.TagGroup
      };
      this.form.PromoCode = this.messageData.PromoCode;
      this.preselection = [];
      for (let [k, v] of Object.entries(this.messageData.tags)) {
        if (v.Selected == "yes") {
          this.preselection.push(v);
        }
      }
      this.form.UnitId = this.messageData.UnitId;
    },
    checkForDate() {
      this.$refs.menu1.save(this.form.date);
      if (
        this.form.date !== null &&
        this.form.time != null &&
        this.form.time != ""
      ) {
        this.isDateFilled = true;
      } else {
        this.isDateFilled = false;
      }
    },
    checkForTime() {
      if (
        this.form.date !== null &&
        this.form.time != null &&
        this.form.time != ""
      ) {
        this.isDateFilled = true;
      } else {
        this.isDateFilled = false;
      }
    },

    closeMessageScreen(reload = false) {
      this.resetDialog();
      this.$emit("closeDialog", reload);
    },

    resetDialog() {
      this.form = {
        Title: "",
        Text: "",
        PromoCode: "",
        tags: [],
        time: null,
        date: null
      };
      this.linda_text1 = this.$translate("MESSAGE_TITLE_1");
      this.linda_text2 = this.$translate("MESSAGE_TITLE_2");
      setTimeout(() => {
        this.step = 0;
      }, 100);
    },
    saveSingleMessage() {
      if (!this.$refs.form.validate()) {
        return;
      }
      console.log("saveSingleMessage the form is ", this.form);

      console.log("eventData of message: ", this.eventData);
      this.form.picture = this.imageProperties.pictureUrl;
      let payload = CommunicationCenterObject._saveSingleMessageObject(
        this.form,
        appConfig.dss.environmentName,
        this.eventData
      );
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      payload.FunctionId = "MessageFunctionLibrary::saveMessage";

      dssRequest.doRequest(
        response => {
          console.log("the generic call saveMessage was successful", response);
          window.EventBus.fire(
            "activateSnackBar",
            "Message saved successfully !"
          );
          this.closeMessageScreen(true);
        },
        error => {
          console.log(
            "The generic call saveMessage was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId + "_CMR",
        payload
      );
    },
    sendSingleMessage() {
      if (this.form.Title == null || this.form.Title == "") {
        this.missingData = true;
        return;
      }
      if (this.form.Text == null || this.form.Text == "") {
        this.missingData = true;
        return;
      }
      this.form.picture = this.imageProperties.pictureUrl;
      let payload = CommunicationCenterObject._sendSingleMessageObject(
        this.form,
        appConfig.dss.environmentName,
        this.eventData
      );
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      dssRequest.doRequest(
        response => {
          console.log("The call for sendMessage was successful", response);
          if (
            response.data.Users != undefined &&
            response.data.Users.MessageUsers != undefined
          ) {
            const users = BaseObject._createArrayWithObjects(
              response.data.Users.MessageUsers
            );
            window.EventBus.fire(
              "activateSnackBar",
              "Message sent successfully! Message sent to " +
                users.length +
                " Users"
            );
          }
          this.closeMessageScreen(true);
        },
        error => {
          console.log("The call for sendMessage was not successful", error);
        },
        "sendMessage",
        this.currentAccountId + "_CMR",
        payload
      );
    }
  }
};
</script>


<style scoped>
.dialogButton {
  width: 100% !important;
  margin: 0px 0px 25px 0px;
}

.itemBorder {
  border-bottom: solid black 1px;
}

@media only screen and (min-width: 960px) {
  .paddingLeft {
    padding-left: 25px;
  }
  .paddingRight {
    padding-right: 25px;
  }
}

.message_dialog_class {
  border-radius: 1em !important;
}

.cardSize {
  max-height: calc(70vh);
  overflow-y: auto;
  overflow-x: hidden;
  height: 100% !important;
}
</style>
